import React, { useState, useEffect, useCallback, useRef } from 'react';
import style from './DepartmentDetail.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import noDataImg from '../../../../../images/common/i_3d_no_data_doc.svg';
import noDoctorImg from '../../../../../images/user/i_3d_hospital_inform_link_01.svg';
import noDoctorImgPng from '../../../../../images/user/i_3d_hospital_inform_link_01.png';
import Skeleton from '@mui/material/Skeleton';
import { useNavigate, useLocation } from 'react-router-dom';
import URL from '../../../../../constants/url';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';

const DepartmentDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { deptName = '알 수 없음', deptDesc = '', deptCode = '', hosptlCd = '' } = location.state || {};

  const DoctorInfoParam = { hsptlCd: hosptlCd, deptCd: deptCode };
  const scrollKey = `deptDetailScrollY-${deptCode}`;

  const [mvTcDoctr, setMvTcDoctr] = useState([]);
  const isSendingRef = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  const getDoctorInitInfo = useCallback(async () => {
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);

        try {
            const res = await axiosApi.post("/guide/doctr/retrieveDoctrList", DoctorInfoParam);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setMvTcDoctr(res.data.result.doctrInfo);
            } else {
                setMvTcDoctr([]);
            }
        } catch (err) {
            console.error(err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
            }, [hosptlCd, deptCode]);

        useEffect(() => {   
            getDoctorInitInfo();
    }, [getDoctorInitInfo]);

  // 스크롤 복원
  useEffect(() => {
    const savedY = sessionStorage.getItem(scrollKey);
    if (savedY !== null) {
        const y = parseInt(savedY, 10);

        const scrollToSaved = () => {
          window.scrollTo(0, y);
        };

        const tryScroll = () => {
          requestAnimationFrame(() => {
              setTimeout(scrollToSaved, 0);
          });
        };
        
        const observer = new MutationObserver(() => {
          tryScroll();
        });

        observer.observe(document.getElementById('sub-content') || document.body, {
          childList: true,
          subtree: true
        });
       
        return () => {
          observer.disconnect();
        };
  }
  
}, [scrollKey]);

  const handleDoctorClick = (doctor) => {
    sessionStorage.setItem(scrollKey, window.scrollY.toString());
    navigate(URL.HOSPITAL_DOCTORDETAIL, {
      state: {
        deptCd: doctor.deptCd,
        deptNm: deptName,
        hosptlCd: doctor.hsptlCd,
        doctNo: doctor.doctrNo,
        docName: doctor.doctrNm,
        hosJbpt: doctor.nuHsptlJbpt,
        schJbpt: doctor.nuSchulJbpt,
        etcJbpt: doctor.nuEtcJbpt,
        docField: doctor.nuClnicField,
      }
    });
  };

  
const handleOnBackClick = ()=> {
  sessionStorage.removeItem(scrollKey);
  navigate(-1);
}


  return (
    <>
      <HeadSub title="상세보기" onBack={handleOnBackClick} />
      <div id="sub-content">
        <div className="inner-wrap" data-padding="0">
          <div className={style['term-box']}>
            <strong>{deptName || '진료과명 없음'}</strong>
            <i className={style['line']}></i>
            
            {/* <span>{deptDesc?.trim() ? deptDesc : '정보 없음'}</span> */}
            {deptDesc === "undefined" ? <></> : <span>{deptDesc}</span>}
          </div>


          <div className={style['doctor-lists-box']}>
            <p>의료진 소개</p>
            <ul>
              {isLoading ? (
                Array.from({ length: 6 }).map((_, index) => (
                  <li key={index} className={style['skeleton-list']}>
                    <span><Skeleton variant="circular" height={40} width={40} /></span>
                    <div className={style['txt-box']}>
                      <p><Skeleton variant="text" height={24} width={50} /></p>
                      <span><Skeleton variant="text" height={20} width={'100%'} /></span>
                    </div>
                  </li>
                ))
              ) : mvTcDoctr.length > 0 ? (
                mvTcDoctr.map((doctor, i) => (
                  <li key={i} onClick={() => handleDoctorClick(doctor)}>
                    <div className={style['avatar-box']}>
                      {!doctor.doctrImgUrl ? (
                        <object data={noDoctorImg} aria-hidden='true'></object>
                      ) : (
                        <img
                          src={doctor.doctrImgUrl}
                          alt="Doctor"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = noDoctorImgPng;
                          }}
                        />
                      )}
                    </div>
                    <div className={style['txt-box']}>
                      <p>{doctor.doctrNm}</p>
                      <span>{doctor.nuClnicField}</span>
                    </div>
                  </li>
                ))
              ) : (
                <li className={style['no-data-box']}>
                  <div className={style['img-box']}>
                    <object data={noDataImg} aria-hidden='true'></object>
                  </div>
                  <p>의료진 정보가 없습니다.</p>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepartmentDetail;
